export default __webpack_public_path__ + "static/media/nuditos.69aab9c8.jpeg";